export default () => ({
    marginLeft: '2rem',
    cursor: 'move',
    '& .anticon': {
        marginRight: '1rem',
    },
    '& .ant-btn .anticon': {
        marginRight: '0',
    },
    '& .delete-info': {
        margin: '0.5rem 0 0 1rem',
    },
});
